import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Language} from "../model/language";
import {LanguageService} from "../service/language.service";

@Injectable()
export class LanguageResolve implements Resolve<Language> {
    constructor(private languageService: LanguageService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Language> {
        return this.languageService.getById(route.params.id);
    }
}